import React, {Component} from 'react';
import ChartList from '../components/ChartList';
import TopMenu from '../components/TopMenu';
import AnalyticsSecondaryMenu from '../components/ChartList/AnalyticsSecondaryMenu';
import {Helmet} from "react-helmet";
import {Navigate} from "react-router-dom";

class Analytics extends Component {
    constructor(props) {
        super(props);
        this.state = {
            chartUpdate: {
                date: ''
            }
        };
        this.updateState = this.updateState.bind(this);
    }
    updateState() {
        this.setState({
            chartUpdate: {
                date: new Date()
            }
        });
    }
    hasNotAccess() {
        return this.props.privileges['Analytics'] === "no access";
    }

    isReadOnly() {
        return this.props.privileges['Analytics'] === "read-only";
    }

    render() {
        if (this.hasNotAccess()) {
            return <Navigate to="/"/>;
        }
        return (
            <div className="analytic-page">
                <Helmet>
                    <title>Analytics</title>
                </Helmet>
                <TopMenu/>
                <AnalyticsSecondaryMenu updateState={this.updateState}
                                        isReadOnly={this.isReadOnly()}
                />
                <div className="main-area">
                    <ChartList showToast={(errorMessage) => this.showToast(errorMessage)}
                               chartUpdate={this.state.chartUpdate}
                               isReadOnly={this.isReadOnly()}
                    />
                </div>
            </div>
        );
    }
}

export default Analytics;
